module.exports = __webpack_public_path__ + "static/media/adp-white.9e692ddf.svg";